// extracted by mini-css-extract-plugin
module.exports = {"gameInfo":"styles_gameInfo__LzU9m","controls":"styles_controls__4oqZm","configKey":"styles_configKey__2bgee"};